export const ArrayEmptyOrNullOrBlanckSpaceRemover = function (request: string): String[] {
  if (request === null || request === "" || request === undefined) {
    return []
  }
  var data = request.split(",");
  if (data.length > 1) {
    var filtered = data.filter(function (el) {
      return el != null && el != "" && el != undefined;
    });
    return filtered;
  }
  return [];
}

export const CheckNotNullAndEmptyAndUndefined = (value: string | undefined): boolean => {
  if (value !== "" && value !== undefined && value !== null) {
    return true;
  }
  return false;
}

export const CheckNotNullOrEmptyOrUndefined = (value: string | undefined): boolean => {
  if (value !== "" || value !== undefined || value !== null) {
    return true;
  }
  return false;
}

export const IsNullEmptyOrUndefined = (value: string | null | undefined): boolean => {
  return value === undefined || value === null || value === ""
}

export const undefinedToNullConverter = (value: any) => {
  if (value === undefined) {
    return null;
  }
  return value;
}

export const undefinedToBoolConverter = (value: any) => {
  if (value === undefined || value === null) {
    return false;
  }
  return value;
}

export const undefinedToStringConverter = (value: any) => {
  if (value === undefined) {
    return '';
  }
  return value;
}

export const nullToStringConverter = (value: any) => {
  if (value === null) {
    return '';
  }
  return value;
}

export const removeLastComma = (value: any) => {
  if (value === null || value === undefined) {
    return '';
  }

  return value.replace(/,\s*$/, "")
}